import { useState, useEffect } from 'react';
import { fetchAffiliates } from '../utils/loaders/affiliateApi';
import { getSelectedIndustryId } from '../utils/industryUtils';

export const useAffiliates = () => {
  const [affiliates, setAffiliates] = useState([]);

  useEffect(() => {
    const fetchAndSetAffiliates = async () => {
      try {
        const industryId = getSelectedIndustryId();
        const affiliatesData = await fetchAffiliates(industryId);
        console.log('ua13 affiliatesData', affiliatesData);
        setAffiliates(affiliatesData);
      } catch (err) {
        console.error('Error fetching affiliates:', err);
      }
    };

    fetchAndSetAffiliates();
  }, []);

  return affiliates;
};
